<template>
    <div class="tile-content">
        <div class="grid-fitted grid-unstackable align-items-center stack-s">
            <div class="grid-item inline-m">
                <h3><span class="inline-s">{{ shippingZone.name | truncate({limit: 26, dots: true}) }}</span></h3>
            </div>
            <div class="grid-item no-flex" v-if="$auth.$pages['edit-shipping-zone'].isAllowed">
                <v-popper2 class="no-flex" position="bottomEnd" :offset="8">
                    <template #trigger="{popper}">
                        <v-icon-button
                            class="no-padding"
                            size="small"
                            type="basic"
                            @click="popper.toggle">
                                <v-icon icon="actions"/>
                        </v-icon-button>
                    </template>
                    <template #content>
                        <div class="popover">
                            <div class="popover-control">
                                <div class="popover-content popover-menu">
                                    <a class="popover-menu-item" @click="editShippingZone">Edit Shipping Zone</a>
                                    <a class="popover-menu-item popover-menu-item-negative" @click="toggleModal">Delete Shipping Zone</a>
                                </div>
                            </div>
                        </div>
                    </template>
                </v-popper2>
            </div>
        </div>
        <div class="grid-fitted stack-m">
            <v-icon v-if="!hasFlag" icon="world" class="inline-s no-flex"/>
            <v-flags v-else :country-code="hasFlag" class="inline-s no-flex"/>
            <p class="grid-item text-muted padding-right-m">{{countrySummary}}</p>
        </div>
        <div v-for="(rate, index) in shippingZone.rates" :key="index" class="margin-left-default">
            <div class="padding-left-s">
                <p>{{rate.name}}</p>
                <div class="grid-fitted grid-unstackable">
                    <span class="grid-item text-muted">{{rateRange(rate.minOrderSubtotal, rate.maxOrderSubtotal, rate.currency)}}</span>
                    <span class="grid-item no-flex"><code
                        class="text">{{ratePrice(rate.price, rate.currency)}}</code></span>
                </div>
                <div v-if="shippingZone.rates.length > index + 1" class="divider margin-top-s margin-bottom-s"></div>
            </div>

        </div>
        <!--Delete Shipping Zone Modal -->
        <v-modal v-if="showDeleteModal" title="Delete Shipping Zone" @close="toggleModal"
                 size="small">
            <div slot="content">
                <p>Are you sure you want to delete this shipping zone?</p>
            </div>
            <template slot="actions">
                <r-button type="danger" @click="deleteShippingZone">Delete Shipping Zone</r-button>
            </template>
        </v-modal>
    </div>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import {
        vIconButton,
        vIcon,
    } from '@/components/form';
    import vPopper2 from '@/components/popper/v-popper2';
    import COUNTRIES from '@/data/countries';
    import listSummary from '@/common/helpers/list-summary';
    import vFlags from '@/components/v-flags';

    export default {
        name: 'shipping-zones-list',
        components: {
            vIconButton,
            vIcon,
            vPopper2,
            vModal,
            vFlags,
        },
        props: {
            shippingZone: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                countries: COUNTRIES,
                showDeleteModal: false,
            };
        },
        computed: {
            countrySummary() {
                const limit = 4;
                if (this.shippingZone.countries !== null) {
                    const countries = this.countries.filter(
                        country => this.shippingZone.countries.includes(country.countryCode),
                    ).map(country => country.countryName);
                    return listSummary(countries, limit);
                }
                return 'Rest of the world (Default)';
            },
            hasFlag() {
                if (this.shippingZone.countries !== null
                    && this.shippingZone.countries.length === 1) {
                    return this.shippingZone.countries[0];
                }
                return false;
            },
        },
        methods: {
            toggleModal() {
                this.showDeleteModal = !this.showDeleteModal;
            },
            rateRange(min, max, currencyCode) {
                const monetize = this.$filters.monetizeExplicit;

                if (max === 0 || max === null) {
                    return `${monetize(min, currencyCode)} and up`;
                }
                return `${monetize(min, currencyCode)} — ${monetize(max, currencyCode)}`;
            },
            ratePrice(price, currencyCode) {
                return `${this.$filters.monetizeExplicit(price, currencyCode)}`;
            },
            deleteShippingZone() {
                this.showDeleteModal = false;
                return this.$emit('delete', this.shippingZone.id);
            },
            editShippingZone() {
                this.$router.push({
                    name: 'edit-shipping-zone',
                    params: {
                        id: this.shippingZone.id,
                    },
                });
            },
        },
    };
</script>
